import { render, staticRenderFns } from "./ErrorBBVAVos.vue?vue&type=template&id=a040d836&scoped=true"
import script from "./ErrorBBVAVos.vue?vue&type=script&lang=js"
export * from "./ErrorBBVAVos.vue?vue&type=script&lang=js"
import style0 from "./ErrorBBVAVos.vue?vue&type=style&index=0&id=a040d836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a040d836",
  null
  
)

export default component.exports